export const MODALYST_APP_DEF_ID = 'f4ef9627-612a-4b63-b8bd-edb7831dcc92';
export const MODALYST_APP_VERSION = '^1.0.0';
export const STORES_APP_DEF_ID = '215238eb-22a5-4c36-9e7b-e7c08025e04e';

export const DEFAULT_APPS = [MODALYST_APP_DEF_ID];
